var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStudent4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "105mm",
    height: "74mm",
    viewBox: "0 0 105 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4496.72 2531.19s-58.97 15.21-90.74 22.63c-20.04 4.67-140.41 39.2-140.41 39.2l-49.97-105.37-41.79 36.41-135.28-56.7-4.74-49.41 315.62-92.07c33.95-4.22 254.42 82.58 254.42 82.58s-98.26 109.89-107.11 122.73",
    style: {
      fill: "#433f53",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.08918 0 0 -.08918 -332.042 244.16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4688.83 1923.71h49.39v393.99h-49.39v-393.99m-754.06 0h-49.38v393.99h49.38v-393.99",
    style: {
      fill: "#855c39",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.08918 0 0 -.08918 -332.042 244.16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4708.3 2239.35h-805.33v114.32h805.33v-114.32",
    style: {
      fill: "#855c39",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.08918 0 0 -.08918 -332.042 244.16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4738.22 2296.5h-852.83v81.94h852.83v-81.94",
    style: {
      fill: "#9d7d61",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.08918 0 0 -.08918 -332.042 244.16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4041.21 2441.07c-26.78 0-48.5-21.7-48.5-48.49 0-26.78 21.72-48.54 48.5-48.54h221.06v97.03h-221.06",
    style: {
      fill: "#515067",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.08918 0 0 -.08918 -332.042 244.16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4263.3 2441.07h-1.03v-97.03h1.03c26.78 0 48.52 21.76 48.52 48.54 0 26.79-21.74 48.49-48.52 48.49",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.08918 0 0 -.08918 -332.042 244.16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4459.39 2138.52h-278.9v102.24h278.9v-102.24",
    style: {
      fill: "#433f53",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.08918 0 0 -.08918 -332.042 244.16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4266.35 2227.4c-30.96 11.35-65.24-4.78-76.58-36.03l-85.96-236.78 120.41-17.01 77.66 212.69c11.34 31.29-4.6 65.82-35.53 77.13",
    style: {
      fill: "#515067",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.08918 0 0 -.08918 -332.042 244.16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4103.81 1954.59c4.71 11.82 98.96 17.69 119.49 3.44 6.56-4.5 10.31-34.32 10.31-34.32h-135.72s2.23 21.54 5.92 30.88",
    style: {
      fill: "#5d524e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.08918 0 0 -.08918 -332.042 244.16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4097.89 1907.97h135.72v15.74h-135.72v-15.74",
    style: {
      fill: "#2f2927",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.08918 0 0 -.08918 -332.042 244.16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4373.55 2227.4c30.96 11.35 65.24-4.78 76.57-36.03l85.97-236.78-120.39-17.01-77.67 212.69c-11.37 31.29 4.59 65.82 35.52 77.13",
    style: {
      fill: "#515067",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.08918 0 0 -.08918 -332.042 244.16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4536.09 1954.59c-4.7 11.82-98.96 17.69-119.51 3.44-6.52-4.5-10.29-34.32-10.29-34.32h135.72s-2.23 21.54-5.92 30.88",
    style: {
      fill: "#5d524e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.08918 0 0 -.08918 -332.042 244.16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4542.01 1907.97h-135.72v15.74h135.72v-15.74",
    style: {
      fill: "#2f2927",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.08918 0 0 -.08918 -332.042 244.16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4357.19 2602.73c25.97-72.23-14.1-157.33-98.48-187.65-84.43-30.35-173.89 3.65-199.84 75.89-67.93 189.01 7.28 164.77 91.7 195.12 84.31 30.33 145.56 86.53 206.62-83.36",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.08918 0 0 -.08918 -332.042 244.16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4149.59 2489.23c3.79-10.54-3.81-22.95-16.93-27.65-13.07-4.67-26.78.04-30.57 10.58-3.75 10.47 3.79 22.85 16.86 27.52 13.12 4.73 26.85.04 30.64-10.45m146.04 52.5c3.8-10.56 17.47-15.27 30.6-10.54 13.11 4.7 20.68 17.03 16.9 27.63-3.81 10.47-17.47 15.18-30.61 10.45-13.14-4.71-20.67-17.05-16.89-27.54",
    style: {
      fill: "#fdb5ac",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.08918 0 0 -.08918 -332.042 244.16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4098.75 2470.95c4.16-11.56-1.86-24.35-13.34-28.45-11.54-4.14-24.28 1.85-28.46 13.41-4.12 11.53 1.9 24.26 13.38 28.42 11.52 4.14 24.32-1.83 28.42-13.38m247.7 89.03c4.19-11.57 16.89-17.58 28.41-13.44 11.57 4.16 17.58 16.87 13.4 28.49-4.14 11.53-16.91 17.48-28.44 13.34-11.5-4.14-17.5-16.87-13.37-28.39",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.08918 0 0 -.08918 -332.042 244.16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4131.31 2600.13c-14.65-5.27-25.29-14.8-28.97-24.33 0 0 12.58 14.19 30.32 20.56 18.51 6.68 36.34 3.38 36.34 3.38-8.86 5.04-23.2 5.61-37.69.39m105.19 37.81c14.59 5.26 28.83 4.63 37.76-.37 0 0-18.71 2.99-36.45-3.38-18.49-6.68-30.23-20.58-30.23-20.58 3.71 9.55 14.33 19.12 28.92 24.33",
    style: {
      fill: "#e69962",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.08918 0 0 -.08918 -332.042 244.16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4235.12 2474.47 2.54-7.11s37.67 10.94 51.75 39.65c0 0-19.43-20.02-54.29-32.54",
    style: {
      fill: "#dab289",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.08918 0 0 -.08918 -332.042 244.16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4235.12 2474.47 2.54-7.11s-36-15.55-65.1-2.36c0 0 27.71-3.01 62.56 9.47m44.51 32.79c6.07-2.48 8.07-.35 16.31-10.49 0 0-4.1 12.95-13.66 14.53-5.25.9-4.45-3.28-2.65-4.04",
    style: {
      fill: "#dab289",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.08918 0 0 -.08918 -332.042 244.16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4179.9 2471.44c-3.08-5.76-5.99-5.41-5.86-18.51 0 0-5.09 12.67 1.23 19.94 3.5 4 5.49.25 4.63-1.43",
    style: {
      fill: "#dab289",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.08918 0 0 -.08918 -332.042 244.16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4063.01 2479.58s-54.96 123.46-52.29 145.4c1.13 8.98 11.94 10.76 11.94 10.76s48.43-14.12 40.35-156.16m298.9 109.87s-4.59 84.98-42.52 119.18c-24.88 22.45-74.78 10.41-74.78 10.41s20.68-25.23 117.3-129.59",
    style: {
      fill: "#e69962",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.08918 0 0 -.08918 -332.042 244.16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4100.08 2722.27c-98.97-25.24-97.46-80.67-55.31-144.99 0 0 29.94-31.45 152.24 12.48 122.27 43.93 129.1 106.24 129.1 106.24-51.85 65.39-183.61 37.09-226.03 26.27",
    style: {
      fill: "#e69962",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.08918 0 0 -.08918 -332.042 244.16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4158.63 2524.31c-10.97 0-22.56 9.63-27.71 24.08-.57 1.55.23 3.3 1.79 3.83 1.55.68 3.31-.25 3.83-1.82 5.06-14.02 16.8-22.85 26.08-19.39 9.31 3.34 12.77 17.52 7.73 31.58-.57 1.55.24 3.28 1.82 3.83 1.52.68 3.28-.21 3.83-1.82 6.17-17.14 1.07-34.78-11.35-39.25-1.95-.71-3.99-1.04-6.02-1.04m89.92 32.31c-10.95 0-22.52 9.61-27.73 24.1-.57 1.54.23 3.26 1.82 3.83 1.54.66 3.28-.22 3.82-1.82 5.08-14.02 16.67-22.7 26.1-19.42 3.26 1.18 5.92 3.79 7.71 7.54 3.05 6.53 3.05 15.51 0 24.05-.56 1.54.24 3.26 1.8 3.83 1.56.68 3.3-.22 3.85-1.82 3.61-9.98 3.51-20.68-.24-28.61-2.46-5.24-6.29-8.91-11.11-10.63-1.95-.7-3.97-1.05-6.02-1.05",
    style: {
      fill: "#433f53",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.08918 0 0 -.08918 -332.042 244.16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4385.98 2441.03c-26.78 0-48.52-21.68-48.52-48.49 0-26.76 21.74-48.5 48.52-48.5h9.86v96.99h-9.86",
    style: {
      fill: "#ffe5ba",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.08918 0 0 -.08918 -332.042 244.16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4608.07 2441.03h-212.23v-96.99h212.23c26.77 0 48.49 21.74 48.49 48.5 0 26.81-21.72 48.49-48.49 48.49",
    style: {
      fill: "#515067",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.08918 0 0 -.08918 -332.042 244.16)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent4);
export default __webpack_public_path__ + "static/media/student4.2af57a77862e559443a830d030297e3a.svg";
export { ForwardRef as ReactComponent };